import {
  Box,
  FormControl,
  InputBase,
  MenuItem,
  Select,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import DownArrow from "../../assets/SVG/downArrow";
import ProfileIcon from "../../assets/SVG/profileIcon";

export default function SelectInput({
  data,
  placeholder,
  width,
  setValue,
  value,
  valueInput,
  setValueInput,
}) {
  const BootstrapInput = styled(InputBase)(({ theme }) => ({
    "& .MuiInputBase-input": {
      borderRadius: 8,
      boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "solid 1px var(--emr-borderInput)",
      fontSize: 16,

      padding: "10px 26px 10px 12px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      "&:focus": {
        borderRadius: 8,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }));
  const refInput = useRef();
  // const [value, setValue] = useState(0);
  const [input, setInput] = useState();
  const handleChange = (event) => {
    setValue(event.target.value);
    // setValue1(event.target.value)
  };
  // useEffect(() => {
  //   if (value === "سایر") {
  //     setInput(true);
  //   } else {
  //     setInput(false);
  //   }
  // }, [value]);
  // console.log(value);
  // console.log(valueInput);
  return (
    <FormControl sx={{ mt: "5px" }} variant="standard">
      {!input && (
        <Select
          ref={refInput}
          IconComponent={(props) => {
            // console.log(props);
            return (
              <Box
                // onClick={() => refInput.current.onClick}
                {...{ className: "", ...props }}
                position="absolute !important"
                top="calc(50% - 0.65em) !important"
                left="0 !important"
                right="auto !important"
                ml="10px !important"
              >
                <DownArrow />
              </Box>
            );
          }}
          value={value}
          onChange={handleChange}
          input={<BootstrapInput />}
          sx={{
            width: width ? width : "100px",
            "& .MuiSelect-select": {
              paddingRight: "10px !important ",
            },
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 40 * 4.5 + 30,
                width: 70,
                backgroundColor: "#F3F3F3",
                borderRadius: "8px",
              },
            },
          }}
          renderValue={(selected) => {
            if (value === 0) {
              return (
                <Typography color={"var(--emr-disable)"}>
                  {placeholder}
                </Typography>
              );
            }

            return value;
          }}
        >
          {data.map((item) => (
            <MenuItem value={item}>{item}</MenuItem>
          ))}
        </Select>
      )}
      {input && (
        <InputBase
          value={valueInput}
          onChange={(e) => setValueInput(e.target.value)}
          autoFocus
          placeholder={placeholder}
          sx={{
            border: "solid 1px var(--emr-borderInput)",
            borderRadius: "8px",
            width: width ? width : "100px",
            px: "10px",
            boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            height: "46px",
          }}
        />
      )}
    </FormControl>
  );
}
